import { createSlice } from '@reduxjs/toolkit';
import {
  addFolder,
  deleteFolder,
  getFolders,
  updateFolder,
} from './foldersAction';

const initialState = {
  loading: false,
  addIsLoading: false,
  folders: [],
  activeFolder: { id: 0, name: 'My Resources' },
  error: null,
  success: false,
};

const foldersSlice = createSlice({
  name: 'folders',
  initialState,
  reducers: {
    setActiveFolder: (state, { payload }) => {
      state.activeFolder = payload;
    },
  },
  extraReducers: {
    // get folders
    [getFolders.pending]: state => {
      state.loading = true;
    },
    [getFolders.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.folders = payload.data;
    },
    [getFolders.rejected]: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },
    // add folder
    [addFolder.pending]: state => {
      state.addIsLoading = true;
    },
    [addFolder.fulfilled]: (state, { payload }) => {
      state.addIsLoading = false;
      // state.folders = payload;
    },
    [addFolder.rejected]: (state, { payload }) => {
      state.addIsLoading = false;
      state.error = payload;
    },
    // update folder
    [updateFolder.pending]: state => {
      state.addIsLoading = true;
    },
    [updateFolder.fulfilled]: (state, { payload }) => {
      state.addIsLoading = false;
      // state.folders = payload;
    },
    [updateFolder.rejected]: (state, { payload }) => {
      state.addIsLoading = false;
      state.error = payload;
    },
    // delete folder
    [deleteFolder.pending]: state => {
      state.addIsLoading = true;
    },
    [deleteFolder.fulfilled]: (state, { payload }) => {
      state.addIsLoading = false;
      state.activeFolder = { id: 0, name: 'My Resources' };
      // state.folders = payload;
    },
    [deleteFolder.rejected]: (state, { payload }) => {
      state.addIsLoading = false;
      state.error = payload;
    },
  },
});

export const { setActiveFolder } = foldersSlice.actions;
export default foldersSlice.reducer;
